import { useEffect, useState } from 'react';
import type { IdTokenResult, User } from 'firebase/auth';
import { getAuthClient } from '../lib/firebase';

export interface IsAdminState {
  isAdmin: boolean;
  loading: boolean;
}

export function extractAdminClaim(tokenResult: IdTokenResult | null): boolean {
  if (!tokenResult) return false;
  return tokenResult.claims?.admin === true;
}

export function useIsAdmin(): IsAdminState {
  const [state, setState] = useState<IsAdminState>({
    isAdmin: false,
    loading: true,
  });

  useEffect(() => {
    const auth = getAuthClient();
    let cancelled = false;

    const readClaim = async (user: User | null) => {
      if (!user) {
        if (!cancelled) setState({ isAdmin: false, loading: false });
        return;
      }
      try {
        const result = await user.getIdTokenResult(true);
        if (!cancelled) {
          setState({ isAdmin: extractAdminClaim(result), loading: false });
        }
      } catch {
        if (!cancelled) setState({ isAdmin: false, loading: false });
      }
    };

    const unsub = auth.onAuthStateChanged((user) => {
      setState((prev) => ({ ...prev, loading: true }));
      void readClaim(user);
    });

    return () => {
      cancelled = true;
      unsub();
    };
  }, []);

  return state;
}
